<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "FinanceManage"
    }
</script>

<style scoped>

</style>
